import { Inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { CookieService } from "ngx-cookie";
import * as URL from "url-parse";
import { apiPath } from "../../../environments/configs";
import { StorageRef } from "../storage/storage.service";
import { AuthTimer } from "./auth-timer";
import { TIMER_START } from "./auth.token"

const tokenKey = "token";

@Injectable()
export class AuthService {

    private jwtHelperService: JwtHelperService;
    private domain: string;

    constructor(private router: Router,
                private cookieService: CookieService,
                private storageRef: StorageRef,
                private authTimer: AuthTimer,
                @Inject(TIMER_START) public countdown: number ) {
        this.jwtHelperService = new JwtHelperService();
        const url = new URL(apiPath());
        const domainIndex = url.hostname.indexOf(".");
        this.domain = url.hostname.substring(domainIndex > 0 ? domainIndex : 0);
    }

    public get bearerToken(): string {
        return `Bearer ${this.storageRef.get("token")}`;
    }

    public isAuthenticated(): boolean {
        try {
            if (this.cookieService.get(tokenKey)) {
                this.storageRef.set(tokenKey, this.cookieService.get(tokenKey));
                this.cookieService.remove(tokenKey, { domain: this.domain });
            }
            const token = this.storageRef.get(tokenKey);
            if (!token || this.jwtHelperService.isTokenExpired(token)) {
                return false;
            }
            const lastUrl = this.storageRef.get("lastAttemptedUrl");
            if (!!lastUrl) {
                this.router.navigate([lastUrl]);
                this.storageRef.unset("lastAttemptedUrl");
            }
            return true;
        } catch (err) {
            return false;
        }
    }

    public setAuthentication(token: string): void {
        if (this.jwtHelperService!.getTokenExpirationDate(token)!.getTime() > (Date.now()) + (this.countdown)) {
            this.storageRef.set(tokenKey, token);
            const timer = (this.jwtHelperService!.getTokenExpirationDate(token)!.getTime() - Date.now()) - (this.countdown);
            this.authTimer.startTimer(timer);
        }
    }

    public unauthorizedRouteAttempt(state) {
        const lastAttemptedUrl = decodeURI(state.url);
        this.storageRef.set("lastAttemptedUrl", lastAttemptedUrl);
        this.router.navigate(["/login"]);
    }

    public logout() {
        this.storageRef.reset();
        this.router.navigate(["/login"]);
    }
}
